module.exports = __webpack_public_path__ + "static/englishiGoLogo-4ee95e0c255a5e2f749fbb099735f151.png";